<template>
	<n-tooltip class="text-fs-xs! px-1.5! py-1!">
		<template #trigger>
			<n-tag :round :color="{ color: 'transparent' }" :size class="text-fs-sm font-normal">
				<template v-if="icon" #icon>
					<Icon :name="icon" :size="sizePX" />
				</template>
				{{ label }}
			</n-tag>
		</template>
		{{ $t(`patients.tags.delivery_date`) }} ({{
			meta.delivery_type === "ASSUMED" ? $t(`patients.tags.assumed`) : $t(`patients.tags.c_section`)
		}})
	</n-tooltip>
</template>

<script setup lang="ts">
import type { PatientMeta } from "@/types/patient"
import { NTag, NTooltip } from "naive-ui"
import { computed } from "vue"
import Icon from "@/components/common/Icon.vue"
import { ICONS } from "@/const"
import { getEstimatedDueDateLabel } from "@/utils/pregnancyCalculator"

const { meta, size } = defineProps<{
	meta: PatientMeta
	round?: boolean
	size?: "small" | "medium" | "large" | "tiny"
}>()

const sizePX = computed(() => (size === "small" ? 12 : size === "large" ? 16 : size === "tiny" ? 10 : 14))

const label = computed(() =>
	meta.delivery_date
		? getEstimatedDueDateLabel(meta.delivery_date, { days_from_delivery: meta.days_from_delivery })
		: "—"
)

const icon = computed<string | null>(() => {
	switch (meta.delivery_type) {
		case "ASSUMED":
			return ICONS.delivery_date_type.assumed
		case "C_SECTION":
			return ICONS.delivery_date_type.c_section
		default:
			return null
	}
})
</script>
